import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.css'],
    standalone: false,
})
export class LoadingSpinnerComponent {
    @Input() custom: boolean = false;
    @Input() size: string = '100';
    @Input() strokeWidth: string = '4';
    @Input() smallSize: boolean = false;
    @Input() title: string;
}
